export default __webpack_public_path__ + "static/media/blog_disp2.bfcb5fbb.png";